<!-- Pop up for prime logisitc station selection -->
<dx-popup
  width="500px"
  height="700px"
  [showTitle]="true"
  [title]="
    'PROJECT_PLANNING.PRIME_LOGISTIC.STATION_SELECTION'
      | translate: { assignmentNo: currentPlAssignment()?.AssignmentNo }
  "
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [visible]="visible()"
  [shading]="true"
  [contentTemplate]="'content'">
  <dxo-position boundaryOffset="0 200" at="top" [of]="'#right-col'" collision="fit"> </dxo-position>
  <div *dxTemplate="let data of 'content'" class="pl-station-content">
    <div class="pl-station-selection">
      <div class="assignment-info">
        {{
          'PROJECT_PLANNING.PRIME_LOGISTIC.STATION_SELECTION_INSTRUCTION'
            | translate: { assignmentNo: currentPlAssignment()?.AssignmentNo }
        }}
      </div>
      <div class="pl-stations-list">
        @for (station of currentPlSubtableData()?.PlStations; track station.AssignmentNo) {
          <div class="station-item">
            <dx-check-box
              [text]="formatPlStationDisplay(station)"
              [value]="selectedPlStations().includes(station.AssignmentNo)"
              (onValueChanged)="onPlStationToggle(station.AssignmentNo, $event)"
              [disabled]="!isPlStationSelectable(station)">
            </dx-check-box>
          </div>
        }
      </div>
      <div class="dialog-buttons">
        <dx-button
          text="{{ 'PROJECT_PLANNING.SELECT' | translate }}"
          [disabled]="hasSelectableStations() && selectedPlStations().length === 0"
          (onClick)="handlePlStationSelected()"></dx-button>
        <dx-button text="{{ 'PROJECT_PLANNING.CANCEL' | translate }}" (onClick)="closeDialog()"></dx-button>
      </div>
    </div>
  </div>
</dx-popup>
